import React from 'react'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf'
import { MotionCard, MotionIcon, MotionImage, MotionSection } from '../motion/Motion'

const items = [
  {
    title: 'Local Manufacturing',
    icon: <PrecisionManufacturingIcon fontSize="small" className="text-white" />,
    imageSrc: '/images/sectionimages/Precision%20Engineering.jpg',
    body:
      'Because we finish our products at our Isando, Kempton Park facility, we control both quality and the clock. This local control is how we achieve our industry-leading 2–3 day delivery — and why every mat leaving our floor meets rigorous SABS quality standards for safety and performance.',
  },
  {
    title: 'Safety First',
    icon: <LocalShippingIcon fontSize="small" className="text-white" />,
    imageSrc: '/images/sectionimages/Logistics%20Solved.jpg',
    body:
      'Our mats are designed with non-slip rubber backing to actively reduce "slip and trip" liability — a critical concern for any Johannesburg facility manager. Every mat is engineered to stay firmly in place under heavy foot traffic, keeping your staff and customers safe.',
  },
  {
    title: 'Sustainability',
    icon: <EnergySavingsLeafIcon fontSize="small" className="text-white" />,
    imageSrc: '/images/sectionimages/Local%20Focus.jpg',
    body:
      'We prioritize durable, long-lasting materials that don\'t need to be replaced every six months. By investing in a mat built to endure years of Johannesburg foot traffic, you reduce waste and achieve a better long-term ROI for your business and the environment.',
  },
]

export default function WhyWeAreDifferentSection() {
  return (
    <MotionSection className="w-full bg-[#ED3994] text-white py-12 lg:py-16 relative overflow-hidden">
      <div className="relative w-[96%] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">Why We Are Different</h2>
          <p className="mt-3 text-white/90 text-sm sm:text-base leading-relaxed">
            We don't just sell mats — we deliver a complete branded matting solution built for the realities of Johannesburg business.
          </p>
        </div>

        <div className="mt-10 lg:mt-12">
          <div className="grid gap-8 lg:gap-10 lg:grid-cols-3">
            {items.map((item, index) => (
              <MotionCard key={item.title} className="w-full" delay={0.03 * index}>
                <div className="w-full h-44 sm:h-52 lg:h-56 overflow-hidden bg-black/10 relative">
                  <MotionImage className="absolute inset-0">
                    <img
                      src={item.imageSrc}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </MotionImage>

                  <div className="absolute top-3 left-3 h-9 w-9 rounded-full bg-black/25 flex items-center justify-center">
                    <MotionIcon>{item.icon}</MotionIcon>
                  </div>
                </div>

                <div className="mt-5 space-y-1">
                  <h3 className="text-base sm:text-lg font-semibold">{item.title}</h3>
                  <p className="text-white/90 text-sm sm:text-base leading-relaxed">{item.body}</p>
                </div>
              </MotionCard>
            ))}
          </div>
        </div>
      </div>
    </MotionSection>
  )
}
